export default __webpack_public_path__ + "static/media/document.29042696.png";